/**
 * Function capitalizes first char of string. All other characters are left untouched.
 * @param word - Word which shall be modified
 * @returns {string}
 */
export const capitalizeFirstLetterOnly = (word: string): string => {
  return word.slice(0, 1).toUpperCase() + word.slice(1)
}
